export const getSelectedQRS = (state) => state.qrCodes.selectedQRS;
export const getQRSSettings = (state) => state.qrCodes;
